import React from 'react';
import { COLORS } from '../../../core/constants/colors';

export interface ProgressStep {
  id: string;
  title: string;
  description: string;
  completed: boolean;
  active: boolean;
}

interface ProgressSidebarProps {
  steps: ProgressStep[];
}

export const ProgressSidebar: React.FC<ProgressSidebarProps> = ({ steps }) => {
  return (
    <div className="w-56 flex-shrink-0 pr-6">
      <div className="mb-8">
        <img
          src="/new_logo_blue.png"
          alt="Portfolio Indexing System"
          className="h-12 mb-8"
        />
      </div>
      <div className="space-y-8">
        {steps.map((step) => (
          <div key={step.id} className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              {step.completed ? (
                <div
                  className="w-5 h-5 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: COLORS.extended.azure }}
                >
                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              ) : step.active ? (
                <div
                  className="w-5 h-5 rounded-full flex items-center justify-center border-2"
                  style={{ borderColor: COLORS.extended.azure }}
                >
                  <div
                    className="w-2.5 h-2.5 rounded-full"
                    style={{ backgroundColor: COLORS.extended.azure }}
                  />
                </div>
              ) : (
                <div
                  className="w-5 h-5 rounded-full border-2"
                  style={{ borderColor: '#D1D5DB', backgroundColor: '#F9FAFB' }}
                />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <p
                className="text-sm font-medium leading-tight"
                style={{
                  color: step.active || step.completed
                    ? COLORS.primary.persianIndigo
                    : '#9CA3AF',
                }}
              >
                {step.title}
              </p>
              <p
                className="text-xs mt-1 leading-tight"
                style={{
                  color: step.active || step.completed
                    ? COLORS.primary.persianIndigo
                    : '#9CA3AF',
                  opacity: 0.8,
                }}
              >
                {step.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

